import React from 'react';
import { Navigate, RouteObject } from 'react-router';

import { url } from 'helpers';
import { InvoicePaymentPage, LoginPage, PasswordResetPage, RegistrationPage } from 'pages';
import { PublicRoute } from 'components/routes';

const publicRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={url.toLogin()} />,
  }, {
    path: url.toLogin(),
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
  }, {
    path: url.toRegistration(),
    element: (
      <PublicRoute>
        <RegistrationPage />
      </PublicRoute>
    ),
  }, {
    path: url.toPasswordReset(),
    element: (
      <PublicRoute>
        <PasswordResetPage />
      </PublicRoute>
    ),
  }, {
    path: url.toInvoicePayment(':displayId'),
    element: <InvoicePaymentPage />,
  },
];

export default publicRoutes;
